export default __webpack_public_path__ + "a1bd7e4839692d9d7c6d989a4f45cbde.png";